import { Controller } from 'stimulus';

class InstallationHelpController extends Controller {
  connect() {
    this.toggleInSerieDropdown();
  }

  toggleInSerieDropdown() {
    this.inSerieDropdownTarget.hidden = this.currentBoilerDropdownTarget.value !== 'CV-ketel';
  }
}

InstallationHelpController.targets = [
  'inSerieDropdown',
  'currentBoilerDropdown',
];

export default InstallationHelpController;
